import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import Dialog from '@material-ui/core/Dialog'
import Fade from '@material-ui/core/Fade'
import { AppStyles, AppTheme } from '../../../../styles/AppTheme'
import { AppHelper } from '../../../../helpers/AppHelper'
import { CommonTheme } from '../../../../styles/Styles'
import { AppButton } from '../../../../common/components/AppButton'

export function ChatbotConfirmDialog(props) {
  const open = !!props.isOpen
  const onGoBack = props.onGoBack
  const onDiscard = props.onDiscard
  return (
    <Dialog
      open={open}
      onClose={onGoBack}
      TransitionComponent={Fade}
      maxWidth='sm'
      fullWidth
      classes={{ root: css(Styles.customRoot), paper: css(Styles.customPaper, AppHelper.isDialogScrollbarEnabled() && AppStyles.dialogScrollbar) }}
    >
      <div className={css(Styles.modalHeader)}>
        <div className={css(Styles.modalTitleContainer)}>
          <div className={css(Styles.modalTitle)}>Confirm</div>
        </div>
        <button type='button' className={css(Styles.modalCloseButton)} onClick={onGoBack}>
          <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
            <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
          </svg>
        </button>
      </div>
      <div className={css(Styles.modalContent)}>
        <p className={css(Styles.confirmMessage)}>You will lose unsaved changes. Are you sure you want to continue?</p>
        <div className={css(Styles.actions)}>
          <AppButton
            buttonText='Stay on this page'
            onClick={onGoBack}
            buttonStyle={Styles.secondaryButton}
            buttonTextStyle={Styles.secondaryButtonText}
          />
          <AppButton
            buttonText='Discard Changes'
            onClick={onDiscard}
            buttonStyle={Styles.discardButton}
            buttonTextStyle={Styles.discardButtonText}
          />
        </div>
      </div>
    </Dialog>
  )
}

const buttonBox = {
  height: 54,
  minHeight: 54,
  minWidth: 210,
  padding: 15,
  borderRadius: AppTheme.borderRadius,
  boxSizing: 'border-box',
  margin: 0,
}

const Styles = StyleSheet.create({
  customRoot: {
    zIndex: 13000,
  },
  customPaper: {
    borderRadius: AppTheme.borderRadius,
    backgroundColor: AppTheme.secondaryBg,
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
    display: 'flex',
    alignItems: 'center',
    gap: 20,
  },
  modalTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '95%',
    flex: 1,
  },
  modalTitle: {
    color: CommonTheme.textColor,
    fontSize: 26,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  modalCloseButton: {
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    border: 'none',
    flexShrink: 0,
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    border: '1.5px solid' + AppTheme.primaryColor,
    fill: AppTheme.primaryColor,
    borderRadius: 8,
  },
  modalContent: {
    paddingLeft: 30,
    paddingRight: 30,
  },
  confirmMessage: {
    color: CommonTheme.textColor,
    fontSize: 20,
    margin: 0,
    lineHeight: 1.4,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
    marginTop: 20,
    marginBottom: 30,
    flexWrap: 'wrap',
  },
  secondaryButton: {
    ...buttonBox,
    backgroundColor: AppTheme.secondaryBg,
    border: '1px solid ' + AppTheme.borderColor,
    boxShadow: 'none',
  },
  secondaryButtonText: {
    color: CommonTheme.textColor,
  },
  discardButton: {
    ...buttonBox,
    backgroundColor: AppTheme.secondaryBg,
    border: '1px solid #E53935',
    boxShadow: 'none',
  },
  discardButtonText: {
    color: '#E53935',
  },
})
